import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import './components/InspectionStyles.css';
import './components/CameraStyles.css';
import { register } from './serviceWorkerRegistration';
import { AuthProvider } from './lib/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

register();
